/** Admin project route base — keep detail/create flows under AdminLayout. */
export const ADMIN_PROJECTS_BASE = "/admin/projects"

export const adminProjectPath = (projectId, ...segments) =>
  [ADMIN_PROJECTS_BASE, projectId, ...segments.filter(Boolean)].join("/")
